module.exports = __webpack_public_path__ + "static/media/iris_editor_sug_small.d045ca2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iris_editor_sug_small.png
// module id = 392
// module chunks = 17